module.exports = __webpack_public_path__ + "img/dd-dice-4.b0019008.png";